// import React, { useState, useEffect, useContext } from "react";
// import { HiMenuAlt3 } from "react-icons/hi";
// import { RxCross2 } from "react-icons/rx";
// // import idea from "../../assets/idea.svg"
// import { IoAddCircleSharp, IoBulbOutline, IoBulbSharp, IoHome, IoPeopleOutline, IoPersonOutline, IoPersonSharp } from "react-icons/io5";
// import { FaChevronDown, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
// import { LuUsers } from "react-icons/lu";
// import { MdOutlineDashboard } from "react-icons/md";
// import { TbReportAnalytics } from "react-icons/tb";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { VscGraph } from "react-icons/vsc";
// import { BsTruckFront, BsBuildingGear } from "react-icons/bs";
// import { handleLogout } from "../Logout/Logout";
// import { FilterContext } from "../../context/Filter";
// import vehicleImage from "../../assets/images/vehicle360.png";
// import { FaTableList } from "react-icons/fa6";
// import { IoIosTimer } from "react-icons/io";
// import { useKeycloak } from "@react-keycloak/web";

// const Navigation = () => {
//   const navigate = useNavigate();
//   const { keycloak } = useKeycloak();
//   const { arn, open, setOpen, submenuOpen, setSubmenuOpen } =
//     useContext(FilterContext);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const location = useLocation();

//   const position = localStorage.getItem("pos_type");
//   const arnRoles = process.env.REACT_APP_ARN_ENRICHMENT_ROLES
//     ?.split(",")
//     .map(r => r.trim());

//   const approverPositions = ["KAM", "NPM", "internal"];
//   const creatorPositions = ["FCM", "RKAM", "NPM", "internal"];

//   const arnEnrichmentMenu =
//     arnRoles?.includes(position)
//       ? {
//         name: "ARN Enrichment",
//         icon: TbReportAnalytics,
//         subMenu: approverPositions.includes(position)
//           ? [{ name: "Approver", link: "/approver" }]
//           : creatorPositions.includes(position)
//             ? [{ name: "Creator", link: "/arnenrichment" }]
//             : [],
//       }
//       : null;


//   const [menu, setMenu] = useState([
//     { name: "Home", link: "/home", icon: IoHome, subMenu: [] },
//   ]);

//   const availableMenus = {
//     "Customer 360": {
//       name: "Customer 360",
//       icon: LuUsers,
//       subMenu: [
//         { name: " Pipeline & Financials", link: "/piplineAndService" },
//         { name: " Service & Spares", link: "/Services" },
//         { name: "Complaints", link: "/complaints" },
//         { name: "FleetEdge", link: "/fleetEdge" },
//         // { name: "Fleet Insights", link: "/fleet-insigths" },
//       ],
//       disabled: arn === "",
//     },

//     "Fleet Insights ": {
//       name: "Fleet Insights",
//       icon: IoBulbSharp,
//       link: "/fleet-insigths",
//       subMenu: [],
//     },
//     "Complaint TAT": {
//       name: "Key Account Complaint TAT",
//       icon: IoIosTimer,
//       link: "/complaint-tat",
//       subMenu: [],
//     },

//     VASDashboard: {
//       name: "VAS Dashboard",
//       icon: VscGraph,
//       link: "/vas-dashboard",
//       subMenu: [],
//     },
//     PVIN: {
//       name: "PVIN",
//       icon: IoPersonOutline,
//       link: "/pvin",
//       subMenu: [],
//     },

//     vehicle360: {
//       name: "Vehicle 360",
//       icon: () => (
//         <img
//           src={vehicleImage}
//           alt="Vehicle 360"
//           style={{ width: "20px", height: "30px" }}
//         />
//       ),
//       link: process.env.REACT_APP_VEHICLE_URL,
//       subMenu: [],
//     },
//   };

//   const finalMenus = {
//     ...availableMenus,
//     ...(arnEnrichmentMenu && { "ARN Enrichment": arnEnrichmentMenu }),
//   };

//   // Close sidebar on route change (useful for mobile)
//   useEffect(() => {
//     setMobileOpen(false);
//     setSubmenuOpen(null);
//   }, [location]);

//   const toggleSubmenu = (menuName, index) => {
//     if (finalMenus[menuName].disabled) return;
//     if (!open) {
//       setOpen(true);
//       setTimeout(() => {
//         setSubmenuOpen(index);
//       }, 300);
//     } else {
//       setSubmenuOpen(submenuOpen === index ? null : index);
//     }
//   };

//   const handleItemSelect = (isMobile = false) => {
//     if (isMobile) {
//       setMobileOpen(false);
//     } else {
//       setOpen(false);
//       setSubmenuOpen(null);
//     }
//   };

//   const renderMenuItems = (isMobile = false) => (
//     <div>
//       {/* Static Home Menu */}
//       {menu.map((item, index) => (
//         <div
//           key={index}
//           className="relative group flex items-center text-[15px] gap-4 p-2 hover:bg-gray-700 rounded-md"
//         >
//           <Link
//             to={item.link}
//             className="flex items-center gap-4"
//             onClick={() => handleItemSelect(isMobile)}
//           >
//             <item.icon size={20} />
//             {(isMobile || open) && <span>{item.name}</span>}

//             {/* Tooltip for collapsed state */}
//             {!open && !isMobile && (
//               <div
//                 className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                 z-[9999] whitespace-nowrap rounded-md 
//                 bg-gray-800 text-white text-xs px-2 py-1 
//                 opacity-0 group-hover:opacity-100 
//                 transition-opacity duration-200 shadow-lg"
//               >
//                 {item.name}
//               </div>
//             )}
//           </Link>
//         </div>
//       ))}

//       {/* Dynamic Menus */}
//       {Object.entries(finalMenus).map(([menuName, menuItem], index) => (
//         <div key={index} className="mt-2">
//           {menuItem.link && !menuItem.subMenu.length ? (
//             // External or internal links
//             menuItem.link.startsWith("http") ? (
//               <a
//                 href={menuItem.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                   ? "opacity-50 cursor-not-allowed"
//                   : "hover:bg-gray-700"
//                   }`}
//                 onClick={() => handleItemSelect(isMobile)}
//               >
//                 <div className="relative flex items-center gap-4">
//                   <menuItem.icon size={20} />
//                   {(isMobile || open) && <span>{menuItem.name}</span>}

//                   {/* Tooltip */}
//                   {!open && !isMobile && (
//                     <div
//                       className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                       z-[9999] whitespace-nowrap rounded-md 
//                       bg-gray-800 text-white text-xs px-2 py-1 
//                       opacity-0 group-hover:opacity-100 
//                       transition-opacity duration-200 shadow-lg"
//                     >
//                       {menuItem.name}
//                     </div>
//                   )}
//                 </div>
//               </a>
//             ) : (
//               <Link
//                 to={menuItem.link}
//                 className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                   ? "opacity-50 cursor-not-allowed"
//                   : "hover:bg-gray-700"
//                   }`}
//                 onClick={() => handleItemSelect(isMobile)}
//               >
//                 <div className="relative flex items-center gap-4">
//                   <menuItem.icon size={20} />
//                   {(isMobile || open) && <span>{menuItem.name}</span>}

//                   {/* Tooltip */}
//                   {!open && !isMobile && (
//                     <div
//                       className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                       z-[9999] whitespace-nowrap rounded-md 
//                       bg-gray-800 text-white text-xs px-2 py-1 
//                       opacity-0 group-hover:opacity-100 
//                       transition-opacity duration-200 shadow-lg"
//                     >
//                       {menuItem.name}
//                     </div>
//                   )}
//                 </div>
//               </Link>
//             )
//           ) : (
//             // Submenu section
//             <div
//               className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                 ? "opacity-50 cursor-not-allowed"
//                 : "hover:bg-gray-700"
//                 }`}
//               onClick={() => toggleSubmenu(menuName, index)}
//             >
//               <div className="relative flex items-center gap-4">
//                 <menuItem.icon size={20} />
//                 {(isMobile || open) && <span>{menuItem.name}</span>}

//                 {/* Tooltip */}
//                 {!open && !isMobile && (
//                   <div
//                     className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                     z-[9999] whitespace-nowrap rounded-md 
//                     bg-gray-800 text-white text-xs px-2 py-1 
//                     opacity-0 group-hover:opacity-100 
//                     transition-opacity duration-200 shadow-lg"
//                   >
//                     {menuItem.name}
//                   </div>
//                 )}
//               </div>

//               {menuItem.subMenu.length > 0 && (isMobile || open) && (
//                 <div>
//                   {submenuOpen === index ? (
//                     <FaChevronDown size={16} />
//                   ) : (
//                     <FaChevronRight size={16} />
//                   )}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Render Submenu */}
//           {submenuOpen === index && menuItem.subMenu.length > 0 && (
//             <div className="ml-6 transition-all duration-300">
//               {menuItem.subMenu.map((subItem, subIndex) => (
//                 <span
//                   key={subIndex}
//                   className={`block p-1 text-[15px] rounded-md cursor-pointer ${menuItem.disabled
//                     ? "text-gray-400 cursor-not-allowed"
//                     : "hover:bg-gray-600"
//                     }`}
//                   onClick={(e) => {
//                     if (menuItem.disabled) {
//                       e.preventDefault();
//                       e.stopPropagation();
//                     } else {
//                       handleItemSelect(isMobile);
//                       navigate(subItem.link);
//                     }
//                   }}
//                 >
//                   {subItem.name}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>
//       ))}

//       {/* Logout */}
//       <div className="mt-2">
//         <div
//           className="relative group flex items-center text-[20px] p-2 hover:bg-gray-700 rounded-md cursor-pointer gap-5"
//           onClick={() => {
//             handleLogout(keycloak);
//             handleItemSelect(isMobile);
//           }}
//         >
//           <FaSignOutAlt />
//           {(isMobile || open) && <span className="text-[15px]">Log Out</span>}

//           {/* Tooltip for logout */}
//           {!open && !isMobile && (
//             <div
//               className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//               z-[9999] whitespace-nowrap rounded-md 
//               bg-gray-800 text-white text-xs px-2 py-1 
//               opacity-0 group-hover:opacity-100 
//               transition-opacity duration-200 shadow-lg"
//             >
//               Log Out
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <>
//       {/* Desktop Sidebar */}
//       <section id="Nevsidebar" className="hidden min-h-screen md:grid gap-6">
//         <div
//           className={`bg-[linear-gradient(90deg,#055096_0%,#4EB0E2_100%)] min-h-screen ${open ? "w-56" : "w-12"
//             } duration-500 text-gray-100 px-2 overflow-visible`}
//         >
//           <div className="py-3 flex mt-2 justify-end">
//             {open ? (
//               <RxCross2
//                 size={window.innerHeight > 800 ? 100 : 28}
//                 className="cursor-pointer"
//                 onClick={() => {
//                   setOpen(false);
//                   setSubmenuOpen(null);
//                 }}
//               />
//             ) : (
//               <HiMenuAlt3
//                 size={26}
//                 className="cursor-pointer"
//                 onClick={() => setOpen(!open)}
//               />
//             )}
//           </div>
//           {renderMenuItems(false)}
//         </div>
//       </section>

//       {/* Mobile Sidebar */}
//       {mobileOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden">
//           <div className="bg-gradient-to-b from-[rgb(51,150,201)] to-[rgb(0,39,75)] min-h-screen w-56 text-gray-100 px-4 fixed z-20">
//             <div className="py-3 flex justify-end">
//               <RxCross2
//                 size={26}
//                 className="cursor-pointer"
//                 onClick={() => setMobileOpen(false)}
//               />
//             </div>
//             {renderMenuItems(true)}
//           </div>
//           <div
//             className="w-full h-full"
//             onClick={() => setMobileOpen(false)}
//           ></div>
//         </div>
//       )}

//       {/* Mobile Menu Toggle Button */}
//       <button
//         className="md:hidden fixed bottom-4 right-4 z-30 bg-blue-600 text-white p-3 rounded-full shadow-lg"
//         onClick={() => setMobileOpen(true)}
//       >
//         <HiMenuAlt3 size={24} />
//       </button>
//     </>
//   );
// };

// export default Navigation;
// import React, { useState, useEffect, useContext } from "react";
// import { HiMenuAlt3 } from "react-icons/hi";
// import { RxCross2 } from "react-icons/rx";
// // import idea from "../../assets/idea.svg"
// import { IoAddCircleSharp, IoBulbOutline, IoBulbSharp, IoHome, IoPeopleOutline, IoPersonOutline, IoPersonSharp } from "react-icons/io5";
// import { FaChevronDown, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
// import { LuUsers } from "react-icons/lu";
// import { MdOutlineDashboard } from "react-icons/md";
// import { TbReportAnalytics } from "react-icons/tb";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { VscGraph } from "react-icons/vsc";
// import { BsTruckFront, BsBuildingGear } from "react-icons/bs";
// import { handleLogout } from "../Logout/Logout";
// import { FilterContext } from "../../context/Filter";
// import vehicleImage from "../../assets/images/vehicle360.png";
// import { FaTableList } from "react-icons/fa6";
// import { IoIosTimer } from "react-icons/io";
// import { useKeycloak } from "@react-keycloak/web";

// const Navigation = () => {
//   const navigate = useNavigate();
//   const { keycloak } = useKeycloak();
//   const { arn, open, setOpen, submenuOpen, setSubmenuOpen } =
//     useContext(FilterContext);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const location = useLocation();

//   const position = localStorage.getItem("pos_type");
//   const arnRoles = process.env.REACT_APP_ARN_ENRICHMENT_ROLES
//     ?.split(",")
//     .map(r => r.trim());

//   const approverPositions = ["KAM", "NPM", "internal"];
//   const creatorPositions = ["FCM", "RKAM", "NPM", "internal"];

//   const arnEnrichmentMenu =
//     arnRoles?.includes(position)
//       ? {
//         name: "ARN Enrichment",
//         icon: TbReportAnalytics,
//         subMenu: approverPositions.includes(position)
//           ? [{ name: "Approver", link: "/approver" }]
//           : creatorPositions.includes(position)
//             ? [{ name: "Creator", link: "/arnenrichment" }]
//             : [],
//       }
//       : null;


//   const [menu, setMenu] = useState([
//     { name: "Home", link: "/home", icon: IoHome, subMenu: [] },
//   ]);

//   const availableMenus = {
//     "Customer 360": {
//       name: "Customer 360",
//       icon: LuUsers,
//       subMenu: [
//         { name: " Pipeline & Financials", link: "/piplineAndService" },
//         { name: " Service & Spares", link: "/Services" },
//         { name: "Complaints", link: "/complaints" },
//         { name: "FleetEdge", link: "/fleetEdge" },
//         // { name: "Fleet Insights", link: "/fleet-insigths" },
//       ],
//       disabled: arn === "",
//     },

//     "Fleet Insights ": {
//       name: "Fleet Insights",
//       icon: IoBulbSharp,
//       link: "/fleet-insigths",
//       subMenu: [],
//     },
//     "Complaint TAT": {
//       name: "Key Account Complaint TAT",
//       icon: IoIosTimer,
//       link: "/complaint-tat",
//       subMenu: [],
//     },

//     VASDashboard: {
//       name: "VAS Dashboard",
//       icon: VscGraph,
//       link: "/vas-dashboard",
//       subMenu: [],
//     },
//     PVIN: {
//       name: "PVIN",
//       icon: IoPersonOutline,
//       link: "/pvin",
//       subMenu: [],
//     },

//     vehicle360: {
//       name: "Vehicle 360",
//       icon: () => (
//         <img
//           src={vehicleImage}
//           alt="Vehicle 360"
//           style={{ width: "20px", height: "30px" }}
//         />
//       ),
//       link: process.env.REACT_APP_VEHICLE_URL,
//       subMenu: [],
//     },
//   };

//   const finalMenus = {
//     ...availableMenus,
//     ...(arnEnrichmentMenu && { "ARN Enrichment": arnEnrichmentMenu }),
//   };

//   // Close sidebar on route change (useful for mobile)
//   useEffect(() => {
//     setMobileOpen(false);
//     setSubmenuOpen(null);
//   }, [location]);

//   const toggleSubmenu = (menuName, index) => {
//     if (finalMenus[menuName].disabled) return;
//     if (!open) {
//       setOpen(true);
//       setTimeout(() => {
//         setSubmenuOpen(index);
//       }, 300);
//     } else {
//       setSubmenuOpen(submenuOpen === index ? null : index);
//     }
//   };

//   const handleItemSelect = (isMobile = false) => {
//     if (isMobile) {
//       setMobileOpen(false);
//     } else {
//       setOpen(false);
//       setSubmenuOpen(null);
//     }
//   };

//   const renderMenuItems = (isMobile = false) => (
//     <div>
//       {/* Static Home Menu */}
//       {menu.map((item, index) => (
//         <div
//           key={index}
//           className="relative group flex items-center text-[15px] gap-4 p-2 hover:bg-gray-700 rounded-md"
//         >
//           <Link
//             to={item.link}
//             className="flex items-center gap-4"
//             onClick={() => handleItemSelect(isMobile)}
//           >
//             <item.icon size={20} />
//             {(isMobile || open) && <span>{item.name}</span>}

//             {/* Tooltip for collapsed state */}
//             {!open && !isMobile && (
//               <div
//                 className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                 z-[9999] whitespace-nowrap rounded-md 
//                 bg-gray-800 text-white text-xs px-2 py-1 
//                 opacity-0 group-hover:opacity-100 
//                 transition-opacity duration-200 shadow-lg"
//               >
//                 {item.name}
//               </div>
//             )}
//           </Link>
//         </div>
//       ))}

//       {/* Dynamic Menus */}
//       {Object.entries(finalMenus).map(([menuName, menuItem], index) => (
//         <div key={index} className="mt-2">
//           {menuItem.link && !menuItem.subMenu.length ? (
//             // External or internal links
//             menuItem.link.startsWith("http") ? (
//               <a
//                 href={menuItem.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                   ? "opacity-50 cursor-not-allowed"
//                   : "hover:bg-gray-700"
//                   }`}
//                 onClick={() => handleItemSelect(isMobile)}
//               >
//                 <div className="relative flex items-center gap-4">
//                   <menuItem.icon size={20} />
//                   {(isMobile || open) && <span>{menuItem.name}</span>}

//                   {/* Tooltip */}
//                   {!open && !isMobile && (
//                     <div
//                       className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                       z-[9999] whitespace-nowrap rounded-md 
//                       bg-gray-800 text-white text-xs px-2 py-1 
//                       opacity-0 group-hover:opacity-100 
//                       transition-opacity duration-200 shadow-lg"
//                     >
//                       {menuItem.name}
//                     </div>
//                   )}
//                 </div>
//               </a>
//             ) : (
//               <Link
//                 to={menuItem.link}
//                 className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                   ? "opacity-50 cursor-not-allowed"
//                   : "hover:bg-gray-700"
//                   }`}
//                 onClick={() => handleItemSelect(isMobile)}
//               >
//                 <div className="relative flex items-center gap-4">
//                   <menuItem.icon size={20} />
//                   {(isMobile || open) && <span>{menuItem.name}</span>}

//                   {/* Tooltip */}
//                   {!open && !isMobile && (
//                     <div
//                       className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                       z-[9999] whitespace-nowrap rounded-md 
//                       bg-gray-800 text-white text-xs px-2 py-1 
//                       opacity-0 group-hover:opacity-100 
//                       transition-opacity duration-200 shadow-lg"
//                     >
//                       {menuItem.name}
//                     </div>
//                   )}
//                 </div>
//               </Link>
//             )
//           ) : (
//             // Submenu section
//             <div
//               className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
//                 ? "opacity-50 cursor-not-allowed"
//                 : "hover:bg-gray-700"
//                 }`}
//               onClick={() => toggleSubmenu(menuName, index)}
//             >
//               <div className="relative flex items-center gap-4">
//                 <menuItem.icon size={20} />
//                 {(isMobile || open) && <span>{menuItem.name}</span>}

//                 {/* Tooltip */}
//                 {!open && !isMobile && (
//                   <div
//                     className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//                     z-[9999] whitespace-nowrap rounded-md 
//                     bg-gray-800 text-white text-xs px-2 py-1 
//                     opacity-0 group-hover:opacity-100 
//                     transition-opacity duration-200 shadow-lg"
//                   >
//                     {menuItem.name}
//                   </div>
//                 )}
//               </div>

//               {menuItem.subMenu.length > 0 && (isMobile || open) && (
//                 <div>
//                   {submenuOpen === index ? (
//                     <FaChevronDown size={16} />
//                   ) : (
//                     <FaChevronRight size={16} />
//                   )}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Render Submenu */}
//           {submenuOpen === index && menuItem.subMenu.length > 0 && (
//             <div className="ml-6 transition-all duration-300">
//               {menuItem.subMenu.map((subItem, subIndex) => (
//                 <span
//                   key={subIndex}
//                   className={`block p-1 text-[15px] rounded-md cursor-pointer ${menuItem.disabled
//                     ? "text-gray-400 cursor-not-allowed"
//                     : "hover:bg-gray-600"
//                     }`}
//                   onClick={(e) => {
//                     if (menuItem.disabled) {
//                       e.preventDefault();
//                       e.stopPropagation();
//                     } else {
//                       handleItemSelect(isMobile);
//                       navigate(subItem.link);
//                     }
//                   }}
//                 >
//                   {subItem.name}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>
//       ))}

//       {/* Logout */}
//       <div className="mt-2">
//         <div
//           className="relative group flex items-center text-[20px] p-2 hover:bg-gray-700 rounded-md cursor-pointer gap-5"
//           onClick={() => {
//             handleLogout(keycloak);
//             handleItemSelect(isMobile);
//           }}
//         >
//           <FaSignOutAlt />
//           {(isMobile || open) && <span className="text-[15px]">Log Out</span>}

//           {/* Tooltip for logout */}
//           {!open && !isMobile && (
//             <div
//               className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
//               z-[9999] whitespace-nowrap rounded-md 
//               bg-gray-800 text-white text-xs px-2 py-1 
//               opacity-0 group-hover:opacity-100 
//               transition-opacity duration-200 shadow-lg"
//             >
//               Log Out
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <>
//       {/* Desktop Sidebar */}
//       <section id="Nevsidebar" className="hidden min-h-screen md:grid gap-6">
//         <div
//           className={`bg-[linear-gradient(90deg,#055096_0%,#4EB0E2_100%)] min-h-screen ${open ? "w-56" : "w-12"
//             } duration-500 text-gray-100 px-2 overflow-visible`}
//         >
//           <div className="py-3 flex mt-2 justify-end">
//             {open ? (
//               <RxCross2
//                 size={window.innerHeight > 800 ? 100 : 28}
//                 className="cursor-pointer"
//                 onClick={() => {
//                   setOpen(false);
//                   setSubmenuOpen(null);
//                 }}
//               />
//             ) : (
//               <HiMenuAlt3
//                 size={26}
//                 className="cursor-pointer"
//                 onClick={() => setOpen(!open)}
//               />
//             )}
//           </div>
//           {renderMenuItems(false)}
//         </div>
//       </section>

//       {/* Mobile Sidebar */}
//       {mobileOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden">
//           <div className="bg-gradient-to-b from-[rgb(51,150,201)] to-[rgb(0,39,75)] min-h-screen w-56 text-gray-100 px-4 fixed z-20">
//             <div className="py-3 flex justify-end">
//               <RxCross2
//                 size={26}
//                 className="cursor-pointer"
//                 onClick={() => setMobileOpen(false)}
//               />
//             </div>
//             {renderMenuItems(true)}
//           </div>
//           <div
//             className="w-full h-full"
//             onClick={() => setMobileOpen(false)}
//           ></div>
//         </div>
//       )}

//       {/* Mobile Menu Toggle Button */}
//       <button
//         className="md:hidden fixed bottom-4 right-4 z-30 bg-blue-600 text-white p-3 rounded-full shadow-lg"
//         onClick={() => setMobileOpen(true)}
//       >
//         <HiMenuAlt3 size={24} />
//       </button>
//     </>
//   );
// };

// export default Navigation;


import React, { useState, useEffect, useContext } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
// import idea from "../../assets/idea.svg"
import { IoAddCircleSharp, IoBulbOutline, IoBulbSharp, IoHome, IoPeopleOutline, IoPersonOutline, IoPersonSharp } from "react-icons/io5";
import { FaChevronDown, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import { LuUsers } from "react-icons/lu";
import { MdOutlineDashboard } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { VscGraph } from "react-icons/vsc";
import { BsTruckFront, BsBuildingGear } from "react-icons/bs";
import { handleLogout, forceLogout } from "../Logout/Logout";
import { FilterContext } from "../../context/Filter";
import vehicleImage from "../../assets/images/vehicle360.png";
import { FaTableList } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";
import { useKeycloak } from "@react-keycloak/web";
import { fetchmenuaccess } from "./Navigationkpi";

// inside Navigation component:
// const { allowedPaths } = useAuth(); // ✅ remove getmenusAccess entirely
const Navigation = () => {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { arn, open, setOpen, submenuOpen, setSubmenuOpen } =
    useContext(FilterContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [menuv, setmenuv] = useState("")
  const location = useLocation();

  const position = localStorage.getItem("pos_type");
  const arnRoles = process.env.REACT_APP_ARN_ENRICHMENT_ROLES
    ?.split(",")
    .map(r => r.trim());



  const pos = localStorage.getItem("pos_type");

  const getmenusAccess = async () => {
    try {
      const res = await fetchmenuaccess({ "position_type": pos });
      if (
        res?.message === "Token expired" ||
        res?.tokenExpired ||
        res?.data?.message === "Token expired"
      ) {
        await forceLogout(keycloak);
        return;
      }
      setmenuv(res);

      // Build allowed paths from API response
      const pathMap = {
        "Pipeline & Financials": "/piplineAndService",
        "Service & Spares": "/Services",
        "Complaints": "/complaints",
        "FleetEdge": "/fleetEdge",
        "Fleet Insights": "/fleet-insigths",
        "Complaint TAT": "/complaint-tat",
        "VAS Dashboard": "/vas-dashboard",
        "PVIN": "/pvin",
        "Creator": "/arnenrichment",
        "Approver": "/approver",
      };

      const allowed = ["/home"]; // always allow home

      res?.data?.forEach((menu) => {
        if (menu.submenus?.length) {
          menu.submenus.forEach((sub) => {
            if (pathMap[sub.sub_menu_name]) {
              allowed.push(pathMap[sub.sub_menu_name]);
            }
          });
        } else {
          if (pathMap[menu.menu_name]) {
            allowed.push(pathMap[menu.menu_name]);
          }
        }
      });

      localStorage.setItem("allowedPaths", JSON.stringify(allowed));
    } catch (error) {
      console.error("❌ Error fetching menu access:", error);
    }
  };
  useEffect(() => {
    getmenusAccess();
  }, [open, submenuOpen]);


  // useEffect(() => {
  //   getmenusAccess();
  // }, []);



  const arnMenuData = menuv?.data?.find(
    (menu) => menu.menu_name === "ARN Enrichment"
  );

  // const arnEnrichmentMenu =
  //   arnRoles?.includes(position) && arnMenuData
  //     ? {
  //       name: arnMenuData.menu_name,
  //       icon: TbReportAnalytics,
  //       subMenu: arnMenuData.submenus?.map((s) => ({
  //         name: s.sub_menu_name,
  //         link:
  //           s.sub_menu_name === "Creator"
  //             ? "/arnenrichment"
  //             : s.sub_menu_name === "Approver"
  //               ? "/approver"
  //               : "#",
  //       })),
  //     }
  //     : null;

  const arnEnrichmentMenu =
    arnMenuData
      ? {
        name: arnMenuData.menu_name,
        icon: TbReportAnalytics,
        subMenu: arnMenuData.submenus?.map((s) => ({
          name: s.sub_menu_name,
          link:
            s.sub_menu_name === "Creator"
              ? "/arnenrichment"
              : s.sub_menu_name === "Approver"
                ? "/approver"
                : "#",
        })),
      }
      : null;


  const [menu, setMenu] = useState([
    { name: "Home", link: "/home", icon: IoHome, subMenu: [] },
  ]);
  const pvinMenu = menuv?.data?.find(
    m => m.menu_name === "PVIN")




  const customer360Menu = menuv?.data?.find(
    m => m.menu_name === "Customer360"
  );

  const fleetMenu = menuv?.data?.find(
    m => m.menu_name === "Fleet Insights"
  );

  const complaintTatMenu = menuv?.data?.find(
    m => m.menu_name === "Key Account Complaint TAT"
  );

  const vasMenu = menuv?.data?.find(
    m => m.menu_name === "VAS Dashboard"
  );

  const vehicleMenu = menuv?.data?.find(
    m => m.menu_name === "Vehicle360"
  );


  const availableMenus = {
    "Customer 360": {
      name: customer360Menu?.menu_name || "Customer 360",
      icon: LuUsers,

      subMenu: (customer360Menu?.submenus || []).map((s) => {
        const customer360Links = {
          "Pipeline & Financials": "/piplineAndService",
          "Service & Spares": "/Services",
          "Complaints": "/complaints",
          "FleetEdge": "/fleetEdge",
        };

        return {
          name: s.sub_menu_name,
          link: customer360Links[s.sub_menu_name] || "#",
        };
      }),

      disabled: arn === "",
    },

    "Fleet Insights": fleetMenu && {
      name: fleetMenu.menu_name,
      icon: IoBulbSharp,
      link: "/fleet-insigths",
      subMenu: [],
    },
    "Complaint": complaintTatMenu && {
      name: complaintTatMenu.menu_name,
      icon: IoIosTimer,
      link: "/complaint-tat",
      subMenu: [],
    },
    "VAS": vasMenu && {
      name: vasMenu.menu_name,
      icon: VscGraph,
      link: "/vas-dashboard",
      subMenu: [],
    },


    "PVIN": pvinMenu && {
      name: pvinMenu.menu_name,
      icon: IoPersonOutline,
      link: "/pvin",
      subMenu: [],
    },



    "Vehicle": vehicleMenu && {
      name: vehicleMenu.menu_name,
      icon: () => (
        <img
          src={vehicleImage}
          alt="Vehicle 360"
          style={{ width: "20px", height: "30px" }}
        />
      ),
      link: process.env.REACT_APP_VEHICLE_URL,
      subMenu: [],
    },
  };
  const finalMenus = Object.fromEntries(
    Object.entries({
      ...availableMenus,
      ...(arnEnrichmentMenu && { "ARN Enrichment": arnEnrichmentMenu }),
    }).filter(([_, v]) => v)
  );


  // const finalMenus = {
  //   ...availableMenus,
  //   ...(arnEnrichmentMenu && { "ARN Enrichment": arnEnrichmentMenu }),
  // };

  // Close sidebar on route change (useful for mobile)
  useEffect(() => {
    setMobileOpen(false);
    setSubmenuOpen(null);
  }, [location]);

  const toggleSubmenu = (menuName, index) => {
    if (finalMenus[menuName].disabled) return;
    if (!open) {
      setOpen(true);
      setTimeout(() => {
        setSubmenuOpen(index);
      }, 300);
    } else {
      setSubmenuOpen(submenuOpen === index ? null : index);
    }
  };

  const handleItemSelect = (isMobile = false) => {
    if (isMobile) {
      setMobileOpen(false);
    } else {
      setOpen(false);
      setSubmenuOpen(null);
    }
  };
  // const renderMenuItems = (isMobile = false) => (
  //   <div>
  //     {Object.entries(finalMenus).map(([menuName, menuItem], index) => (
  //       <div key={index}>{menuItem.name}</div>
  //     ))}
  //   </div>
  // );

  const renderMenuItems = (isMobile = false) => (
    <div>
      {/* Static Home Menu */}
      {menu.map((item, index) => (
        <div
          key={index}
          className="relative group flex items-center text-[15px] gap-4 p-2 hover:bg-gray-700 rounded-md"
        >
          <Link
            to={item.link}
            className="flex items-center gap-4"
            onClick={() => handleItemSelect(isMobile)}
          >
            <item.icon size={20} />
            {(isMobile || open) && <span>{item.name}</span>}

            {/* Tooltip for collapsed state */}
            {!open && !isMobile && (
              <div
                className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
                z-[9999] whitespace-nowrap rounded-md 
                bg-gray-800 text-white text-xs px-2 py-1 
                opacity-0 group-hover:opacity-100 
                transition-opacity duration-200 shadow-lg"
              >
                {item.name}
              </div>
            )}
          </Link>
        </div>
      ))}

      {/* Dynamic Menus */}
      {Object.entries(finalMenus).map(([menuName, menuItem], index) => (
        <div key={index} className="mt-2">
          {menuItem.link && !menuItem.subMenu.length ? (
            // External or internal links
            menuItem.link.startsWith("http") ? (
              <a
                href={menuItem.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-gray-700"
                  }`}
                onClick={() => handleItemSelect(isMobile)}
              >
                <div className="relative flex items-center gap-4">
                  <menuItem.icon size={20} />
                  {(isMobile || open) && <span>{menuItem.name}</span>}

                  {/* Tooltip */}
                  {!open && !isMobile && (
                    <div
                      className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
                      z-[9999] whitespace-nowrap rounded-md 
                      bg-gray-800 text-white text-xs px-2 py-1 
                      opacity-0 group-hover:opacity-100 
                      transition-opacity duration-200 shadow-lg"
                    >
                      {menuItem.name}
                    </div>
                  )}
                </div>
              </a>
            ) : (
              <Link
                to={menuItem.link}
                className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-gray-700"
                  }`}
                onClick={() => handleItemSelect(isMobile)}
              >
                <div className="relative flex items-center gap-4">
                  <menuItem.icon size={20} />
                  {(isMobile || open) && <span>{menuItem.name}</span>}

                  {/* Tooltip */}
                  {!open && !isMobile && (
                    <div
                      className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
                      z-[9999] whitespace-nowrap rounded-md 
                      bg-gray-800 text-white text-xs px-2 py-1 
                      opacity-0 group-hover:opacity-100 
                      transition-opacity duration-200 shadow-lg"
                    >
                      {menuItem.name}
                    </div>
                  )}
                </div>
              </Link>
            )
          ) : (
            // Submenu section
            <div
              className={`relative group flex items-center text-[15px] justify-between p-2 rounded-md cursor-pointer ${menuItem.disabled
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-700"
                }`}
              onClick={() => toggleSubmenu(menuName, index)}
            >
              <div className="relative flex items-center gap-4">
                <menuItem.icon size={20} />
                {(isMobile || open) && <span>{menuItem.name}</span>}

                {/* Tooltip */}
                {!open && !isMobile && (
                  <div
                    className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
                    z-[9999] whitespace-nowrap rounded-md 
                    bg-gray-800 text-white text-xs px-2 py-1 
                    opacity-0 group-hover:opacity-100 
                    transition-opacity duration-200 shadow-lg"
                  >
                    {menuItem.name}
                  </div>
                )}
              </div>

              {menuItem.subMenu.length > 0 && (isMobile || open) && (
                <div>
                  {submenuOpen === index ? (
                    <FaChevronDown size={16} />
                  ) : (
                    <FaChevronRight size={16} />
                  )}
                </div>
              )}
            </div>
          )}

          {/* Render Submenu */}
          {submenuOpen === index && menuItem.subMenu.length > 0 && (
            <div className="ml-6 transition-all duration-300">
              {menuItem.subMenu.map((subItem, subIndex) => (
                <span
                  key={subIndex}
                  className={`block p-1 text-[15px] rounded-md cursor-pointer ${menuItem.disabled
                    ? "text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-600"
                    }`}
                  onClick={(e) => {
                    if (menuItem.disabled) {
                      e.preventDefault();
                      e.stopPropagation();
                    } else {
                      handleItemSelect(isMobile);
                      navigate(subItem.link);
                    }
                  }}
                >
                  {subItem.name}
                </span>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Logout */}
      <div className="mt-2">
        <div
          className="relative group flex items-center text-[20px] p-2 hover:bg-gray-700 rounded-md cursor-pointer gap-5"
          onClick={() => {
            handleLogout(keycloak);
            handleItemSelect(isMobile);
          }}
        >
          <FaSignOutAlt />
          {(isMobile || open) && <span className="text-[15px]">Log Out</span>}

          {/* Tooltip for logout */}
          {!open && !isMobile && (
            <div
              className="absolute left-full top-1/2 -translate-y-1/2 ml-2 
              z-[9999] whitespace-nowrap rounded-md 
              bg-gray-800 text-white text-xs px-2 py-1 
              opacity-0 group-hover:opacity-100 
              transition-opacity duration-200 shadow-lg"
            >
              Log Out
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <section id="Nevsidebar" className="hidden min-h-screen md:grid gap-6">
        <div
          className={`bg-[linear-gradient(90deg,#055096_0%,#4EB0E2_100%)] min-h-screen ${open ? "w-56" : "w-12"
            } duration-500 text-gray-100 px-2 overflow-visible`}
        >
          <div className="py-3 flex mt-2 justify-end">
            {open ? (
              <RxCross2
                size={window.innerHeight > 800 ? 100 : 28}
                className="cursor-pointer"
                onClick={() => {
                  setOpen(false);
                  setSubmenuOpen(null);
                }}
              />
            ) : (
              <HiMenuAlt3
                size={26}
                className="cursor-pointer"
                onClick={() => setOpen(!open)}
              />
            )}
          </div>
          {renderMenuItems(false)}
        </div>
      </section>

      {/* Mobile Sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden">
          <div className="bg-gradient-to-b from-[rgb(51,150,201)] to-[rgb(0,39,75)] min-h-screen w-56 text-gray-100 px-4 fixed z-20">
            <div className="py-3 flex justify-end">
              <RxCross2
                size={26}
                className="cursor-pointer"
                onClick={() => setMobileOpen(false)}
              />
            </div>
            {renderMenuItems(true)}
          </div>
          <div
            className="w-full h-full"
            onClick={() => setMobileOpen(false)}
          ></div>
        </div>
      )}

      {/* Mobile Menu Toggle Button */}
      <button
        className="md:hidden fixed bottom-4 right-4 z-30 bg-blue-600 text-white p-3 rounded-full shadow-lg"
        onClick={() => setMobileOpen(true)}
      >
        <HiMenuAlt3 size={24} />
      </button>
    </>
  );
};

export default Navigation;
